import { Component, Injector, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { InfoOption } from '@app/forms/subscription/components/info/info.component';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'option-legal-entity',
    templateUrl: './option-legal-entity.component.html',
    styleUrls: ['./option-legal-entity.component.scss'],
    standalone: false
})
export class OptionLegalEntityComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  optionInfo1: InfoOption = {
    icon: 'warning',
    backgroundColor: 'var(--info-alert-bg-color)',
    iconColor: 'var(--info-alert-font-color)',
    textColor: 'var(--info-alert-font-color)',
  };
  options: FormControlOption[] = [
    {
      label: 'Bien supplémentaire',
      value: '300€ TTC',
      displayValue: '€ TTC',
      hardFormControlName: 'additionalPropertyTotal',

      suffix: 'A',
      formControlName: 'additionalPropertyOption',
      input: {
        formControlName: 'additionalPropertyNumber',
      },
    },
    // {
    //   label: "Simulation optimisée",
    //   value: "120€ TTC",
    //   displayValue: "€ TTC",
    //   hardFormControlName: "optimizedOptimization",
    //   suffix: "B",
    //   formControlName: "optimizedSimulationOption",

    //   description:
    //     "Simulation approfondie selon vos critères dans le cadre de votre activité de loueur existante ou à venir.",
    // },

    // {
    //   label: "Simulation sur mesures",
    //   value: "Simulation sur mesures",
    //   suffix: "C",
    //   formControlName: "customizedSimulationOption",
    //   input: {
    //     formControlName: "customizedOptimization",
    //   },
    //   description: "Simulation sur mesure affinée avec un conseiller.",
    // },
  ];
  isConsultant: boolean = false;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.isConsultant = !!this.subscriptionFacade?.getUser()?.sessionConsultant;
    if (!this.isConsultant) {
      this.options = this.options.filter(
        option => option.value != 'Simulation sur mesures',
      );
    }
    this.subscriptionFacade.initForm(this);
    this.subscribeToProductValueChanges();
    this.subscribeToAdditionalPropertyNumberChanges();
  }

  private subscribeToAdditionalPropertyNumberChanges() {
    const product = this.products?.get('0');
    if (!product) return;
    product
      ?.get('parameters')
      ?.get('additionalPropertyNumber')
      ?.valueChanges.subscribe(value => {
        product
          ?.get('parameters')
          ?.get('additionalPropertyTotal')
          ?.setValue(value * 60);
      });
  }

  private subscribeToProductValueChanges() {
    const product = this.products?.get('0');
    if (!product) return;

    product.valueChanges.subscribe(({ parameters }) => {
      const { additionalPropertyOption, additionalPropertyNumber } =
        parameters || {};
      if (additionalPropertyOption && !additionalPropertyNumber) {
        product
          ?.get('parameters')
          ?.get('additionalPropertyNumber')
          ?.setValue(1);
        this.products
          .get('0')
          ?.get('parameters')
          ?.get('additionalPropertyTotal')
          ?.setValue(additionalPropertyNumber);
        product
          ?.get('parameters')
          ?.get('additionalPropertyTotal')
          ?.setValue(60);
      } else if (!additionalPropertyOption && additionalPropertyNumber) {
        product
          ?.get('parameters')
          ?.get('additionalPropertyNumber')
          ?.setValue(0);
      }
    });
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
  select(option: FormControlOption) {
    const checked = this.products
      .get('0')
      ?.get('parameters')
      ?.get(option.formControlName)?.value;

    if (!checked) {
      this.products
        .get('0')
        ?.get('parameters')
        ?.get(option.formControlName)
        ?.setValue(true);
    }
  }
}
